import React from 'react'
import './ContactContactInfo.css'
import Info1 from '../../../Img/info-1.png';
import Info2 from '../../../Img/info-2.png';
import Info3 from '../../../Img/info-3.png';
import ContactFormWidget from '../../../Components/ContactInfo/contact-form-widget'


const ContactContactInfo = () => {
  return (
    <div className="main">
    <div class="section contact-info-section section-padding-02">
            <div class="container">
                {/* <!-- Contact Info Wrap Start --> */}
                <div class="contact-info-wrap">
                    <div class="row">
                        <div class="col-lg-4 col-sm-6">
                            {/* <!--Single Contact Info Start --> */}
                            <div class="single-contact-info text-center">
                                <div class="info-icon">
                                    <img src={Info1} alt=""/>
                                </div>
                                <div class="info-content">
                                    <h5 class="title">Give us a call</h5>
                                    <p><a href="tel:+918003773959" target='_blank'>+91 80037 73959</a></p>
                                </div>
                            </div>
                            {/* <!--Single Contact Info End --> */}
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            {/* <!--Single Contact Info Start --> */}
                            <div class="single-contact-info text-center">
                                <div class="info-icon">
                                <img src={Info2} alt=""/>
                                </div>
                                <div class="info-content">
                                    <h5 class="title">Drop us a line</h5>
                                    <p>info@harsafe.com</p>
                                </div>
                            </div>
                            {/* <!--Single Contact Info End --> */}
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            {/* <!--Single Contact Info Start --> */}
                            <div class="single-contact-info text-center">
                                <div class="info-icon">
                                <img src={Info3} alt=""/>
                                </div>
                                <div class="info-content">
                                    <h5 class="title">Visit our office</h5>
                                    <p>Ward No.8, Srimadhopur Bazar, Srimadhopur, Sikar, Rajasthan, India, 332715</p>
                                    {/* <p>Behind Deputy Office,Reengus Sikar Rajasthan (332403)</p> */}
                                </div>
                            </div>
                            {/* <!--Single Contact Info End --> */}
                        </div>
                    </div>
                </div>
                {/* <!-- Contact Info Wrap End --> */}
            </div>
        </div>

        <div class="section harsafe-contact-section harsafe-contact-section-02 harsafe-contact-section-03 section-padding-02">
            <div class="container">
                {/* <!-- Contact Wrap Start --> */}
                <div class="contact-wrap">
                    <div class="row justify-content-center">
                        <div class="col-lg-10">
                            {/* <!-- Contact Form Start --> */}
                            <div class="contact-form">
                                <div class="contact-form-wrap">
                                    <div class="heading-wrap text-center">
                                        <span class="sub-title"> request a quote</span>
                                        <h3 class="title">How May We Help You!</h3>
                                    </div>
                                    <ContactFormWidget />
                                    {/* <form action="#">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <div class="single-form">
                                                    <input type="text" placeholder="Name *"/>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="single-form">
                                                    <input type="email" placeholder="Email *"/>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="single-form">
                                                    <input type="text" placeholder="Subject *"/>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="single-form">
                                                    <textarea placeholder="Write A Message"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="form-btn">
                                                    <button class="btn" type="submit">Send Message</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form> */}
                                </div>
                            </div>
                            {/* <!-- Contact Form End --> */}
                        </div>
                    </div>
                </div>
                {/* <!-- Contact Wrap End --> */}
            </div>
        </div>

        {/* <!-- Contact Map Start --> */}
        <div class="section contact-map-section map-padding">
            <div class="contact-map-wrap">
            <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1770.156999057409!2d75.59591136560506!3d27.4594822624918!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396ce73b790e2aa9%3A0x48ded8256dbd3e4b!2sMD%20BROTHERS!5e0!3m2!1sen!2sin!4v1734431730070!5m2!1sen!2sin" width="600" height="450" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Map"></iframe>
      </div>
        </div>
        {/* <!-- Contact Map End --> */}


        </div>
  )
}

export default ContactContactInfo